import { useEffect, useMemo, useState } from "react";
import Header from "./components/home/Header";
import MiniCart from "./components/home/MiniCart";
import HeroSection from "./components/home/HeroSection";
import USPSection from "./components/home/USPSection";
import VermicompostSection from "./components/home/VermicompostSection";
import VermiwashSection from "./components/home/VermiwashSection";
import UseCasesSection from "./components/home/UseCasesSection";
import LandscapingSection from "./components/home/LandscapingSection";
import AboutSection from "./components/home/AboutSection";
import ApplicationGuideSection from "./components/home/ApplicationGuideSection";
import TestimonialsSection from "./components/home/TestimonialsSection";
import VideosSection from "./components/home/VideosSection";
import FAQSection from "./components/home/FAQSection";
import ShippingBanner from "./components/home/ShippingBanner";
import CTABanner from "./components/home/CTABanner";
import Footer from "./components/home/Footer";
import SEOHead from "./components/seo/SEOHead";

export default function ParasOrganicsHome() {
  const [scrolled, setScrolled] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems] = useState([]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const schema = useMemo(() => [
    {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Paras Organics",
      "url": "https://parasorganics.com",
      "logo": "https://parasorganics.com/favicon.png"
    },
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Paras Organics",
      "url": "https://parasorganics.com",
      "description": "Organic Vermicompost and Vermiwash for home gardens, farms, nurseries, and landscaping."
    }
  ], []);

  return (
    <>
      <SEOHead
        title="Organic Vermicompost & Vermiwash"
        description="Shop Paras Organics Vermicompost and Vermiwash for chemical-free plant nutrition, healthier soil, home gardening, organic farming, and landscaping."
        path="/"
        image="/favicon.png"
        schema={schema}
      />
      <Header scrolled={scrolled} cartItems={cartItems} onCartClick={() => setCartOpen((open) => !open)} />
      {cartOpen && <MiniCart cartItems={cartItems} onClose={() => setCartOpen(false)} />}
      <main>
        <HeroSection />
        <USPSection />
        <VermicompostSection />
        <VermiwashSection />
        <UseCasesSection />
        <LandscapingSection />
        <AboutSection />
        <ApplicationGuideSection />
        <TestimonialsSection />
        <VideosSection />
        <ShippingBanner />
        <FAQSection />
        {/* <BlogSection />*/}
        <CTABanner />
      </main>
      <Footer />
    </>
  );
}
